import { render, staticRenderFns } from "./FormToolbar.vue?vue&type=template&id=56d17f13&scoped=true"
import script from "./FormToolbar.vue?vue&type=script&lang=js"
export * from "./FormToolbar.vue?vue&type=script&lang=js"
import style0 from "./FormToolbar.vue?vue&type=style&index=0&id=56d17f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d17f13",
  null
  
)

export default component.exports